import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { APP_FONT_FAMILY } from "../constants/typography";

const FinancePaymentCancelContent = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ textAlign: "center", mt: 6, px: 2, maxWidth: 640, mx: "auto", fontFamily: APP_FONT_FAMILY }}>
      <CancelIcon sx={{ fontSize: 64, color: "#EF4444", mb: 2 }} />
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
        {t("finance_payment_cancelled") || "Payment cancelled"}
      </Typography>
      <Typography sx={{ color: "text.secondary", mb: 3 }}>
        {t("finance_payment_no_charge") || "No charge was made."}
      </Typography>
    </Box>
  );
};

const FinancePaymentCancel = () => <FinancePaymentCancelContent />;

export default FinancePaymentCancel;
